export default __webpack_public_path__ + "static/media/uz.d955e098.jpg";